<template>
  <div class="mt-md-3 mx-md-8 mx-lg-16">
    <v-card flat>
      <v-card-title>
        Neues Konto Erzeugen
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mx-0">
          <div style="width: 600px" class="mr-md-12">
            <account-editor ref="accountEditor"> </account-editor>
          </div>
        </v-row>
      </v-card-text>
      <v-divider class="mt-3" />
      <v-card-actions>
        <v-btn color="primary" elevation="0" @click="doAccountSubmission()">
          Erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AccountEditor from "@/components/financial/AccountEditor";

export default {
  name: "AccountSubmission",
  components: { AccountEditor },
  methods: {
    ...mapActions("financial", ["submitAccount"]),
    doAccountSubmission() {
      if (this.$refs.accountEditor.validate()) {
        let newAccount = this.$refs.accountEditor.getAccount();
        this.submitAccount(newAccount);
        this.$router.push("/financial/accounts");
      } else {
        this.$vuetify.goTo(1, { duration: 650 });
      }
    }
  },
  computed: {
    ...mapGetters("user", ["isAdmin", "isStavo", "isTreasurer"]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  }
};
</script>

<style scoped></style>
